import { SUPPORT_PHONENO } from '../../../../commons/Constants';
import styles from '../Policies.module.scss';

export default function ReturnsPage() {
  return (
    <div className={styles.policyContainer}>
      <h1 className={styles.policyTitle}>Returns Policy</h1>
      <h2 className={styles.policySectionHeader}>Product Returns</h2>
      <div className={styles.policySection}>
        We truly value your business! If for any reason you'd like to return
        products you’ve purchased directly from Relief Factor, whether online or
        over the phone, we're here to help.
      </div>

      <h2 className={styles.policySectionHeader}>Return Guidelines:</h2>
      <ul className={styles.spaceTop}>
        <li>Please ensure products are not opened, damaged, or defaced.</li>
        <li>Remember, shipping and handling costs aren't refundable.</li>
        <li>
          Kindly send back products within 60 days from when you first received
          them.
        </li>
      </ul>
      <h2 className={styles.policySectionHeader}>Easy Return Steps:</h2>
      <ul className={styles.spaceTop}>
        <li>
          Want to avoid return postage? Just mark the unopened shipping bag as
          "REFUSED" and pop it in the mail or hand it over at your local post
          office.
        </li>
        <li>
          If the shipping bag has been opened, you'll need to cover the return
          postage.
        </li>
        <li>
          Need a hand with the process? Our friendly Customer Experience Team is
          available at {''}
          <a className="phone-link" href={`tel:+1-${SUPPORT_PHONENO}`}>
            {SUPPORT_PHONENO}
          </a>{' '}
          (Monday to Friday, 8am - 9pm ET) to guide you.
        </li>
      </ul>
      <h2 className={styles.policySectionHeader}>Return by mail to:</h2>
      <div className={`${styles.policySection} ${styles.spaceTop}`}>
        <div>Relief Factor Co.</div>
        <div>11031 117th Place NE</div>
        <div>Kirkland, WA 98033</div>
      </div>
      <h2 className={styles.policySectionHeader}>Please Note:</h2>
      <ul className={styles.spaceTop}>
        <li>We usually process refunds the day we get your return.</li>
        <li>
          Refund may take a little over a week to show up on your account due to
          bank processing time. Unfortunately, we have no influence over how
          long banks take to process refunds.
        </li>
        <li>
          We might not have tracking details for your return shipment, but rest
          assured, we're on it!
        </li>
      </ul>
    </div>
  );
}
